import React, { useMemo } from "react";
import { Card, CardBody, Badge } from "reactstrap";

const DnaDetailsHeader = ({ selectedDna }) => {
  const header = useMemo(() => {
    if (!selectedDna) return null;

    const dimType = selectedDna?.DimType ?? selectedDna?.dimType ?? "";
    const method =
      selectedDna?.MethodOfRecording ?? selectedDna?.methodOfRecording ?? "";
    const min = selectedDna?.Min ?? selectedDna?.min ?? "";
    const max = selectedDna?.Max ?? selectedDna?.max ?? "";

    return {
      dna: selectedDna?.DNANum ?? selectedDna?.dnaNum ?? "",
      desc: selectedDna?.Description ?? selectedDna?.description ?? "",
      tool: selectedDna?.Tool ?? selectedDna?.tool ?? "",
      dimType,
      method,
      min,
      max,
    };
  }, [selectedDna]);

  return (
    <Card className="shadow-sm" style={{ borderRadius: 12 }}>
      <CardBody>
        {!selectedDna ? (
          <div className="text-muted">No DNA selected.</div>
        ) : (
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: 10,
              alignItems: "center",
            }}
          >
            <div style={{ fontWeight: 800, fontSize: 16 }}>
              DNA {header?.dna || "—"}
            </div>

            {header?.tool ? <Badge color="info">Tool: {header.tool}</Badge> : null}
            {header?.dimType ? (
              <Badge color="secondary">DimType: {header.dimType}</Badge>
            ) : null}
            {header?.method ? (
              <Badge color="dark">Method: {header.method}</Badge>
            ) : null}

            {(header?.min !== "" || header?.max !== "") && (
              <Badge color="success">
                Spec: {header?.min !== "" ? `Min ${header.min}` : "Min —"}{" "}
                {header?.max !== "" ? `Max ${header.max}` : "Max —"}
              </Badge>
            )}

            {header?.desc ? (
              <div style={{ width: "100%", fontSize: 12, color: "#6c757d" }}>
                {header.desc}
              </div>
            ) : null}
          </div>
        )}
      </CardBody>
    </Card>
  );
};

export default React.memo(DnaDetailsHeader);